enum CSSRuleTypeEnum {
	containerRule = 0,
	styleRule = 1,
	importRule = 3,
	mediaRule = 4,
	fontFaceRule = 5,
	pageRule = 6,
	keyframesRule = 7,
	keyframeRule = 8,
	namespaceRule = 10,
	counterStyleRule = 11,
	supportsRule = 12,
	documentRule = 13,
	fontFeatureValuesRule = 14,
	regionStyleRule = 16
}

export default CSSRuleTypeEnum;
